export const MAX_CONTENT_WIDTH = 775
export const PAGE_LAYOUT_CONTENT_WIDTH = 634
export const MIN_BODY_HEIGHT = '70vh'
